import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Typography } from 'seagull';
import { Bell } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
import { NotificationSettingsEntryType } from '~/models/NotificationSettingsModel';
import { Tab } from '../../../NotificationSettings.utils';
import { CadenceDaysDropdown } from './CadenceDaysDropdown';
import { CadenceTimesDropdown } from './CadenceTimesDropdown';
import { GetNotifyRowTID } from './NotifyRow.testIds';
import { RecipientsDropdown } from './RecipientsDropdown';
export const NotifyRow = (param)=>{
    let { selectedTab, notificationType, notificationName, recipientTypes, recipientTypeOptions, recipientsEditable, recipientsError, minutes, times, onChangeRecipients, onChangeMinutes, onChangeTimes } = param;
    const { NotifyRowTestIds: testIds } = useMemo(()=>GetNotifyRowTID(), []);
    const { t: contentTexts } = useLocaleKeys('pages.notificationSettings.contentCustomization');
    const isVendor = selectedTab === Tab.Vendor;
    const isRecurring = notificationType === NotificationSettingsEntryType.Recurring;
    const showRecipientsBlock = isVendor && recipientsEditable;
    const showCadenceBlock = isRecurring;
    if (!showRecipientsBlock && !showCadenceBlock) return null;
    const showLabel = isVendor ? recipientsEditable : true;
    const isRemindRow = !isVendor && isRecurring;
    const rowLabel = isVendor ? contentTexts.notifyRowLabel() : isRecurring ? contentTexts.remindClientLabel() : contentTexts.notifyClientLabel();
    return /*#__PURE__*/ _jsxs(Box, {
        gap: 8,
        alignItems: "center",
        wrap: true,
        style: {
            marginTop: 4
        },
        testId: testIds.Root(),
        children: [
            isRemindRow && /*#__PURE__*/ _jsx(Bell, {
                size: 24,
                testId: testIds.Bell()
            }),
            showLabel && /*#__PURE__*/ _jsx(Typography, {
                weight: "bold",
                children: rowLabel
            }),
            showRecipientsBlock && /*#__PURE__*/ _jsx(RecipientsDropdown, {
                notificationName: notificationName,
                recipientTypes: recipientTypes,
                recipientTypeOptions: recipientTypeOptions,
                error: recipientsError,
                onChange: onChangeRecipients
            }),
            isRecurring && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        children: isVendor ? contentTexts.cadenceConnectorAfter() : contentTexts.cadenceConnectorEvery()
                    }),
                    /*#__PURE__*/ _jsx(CadenceDaysDropdown, {
                        selectedTab: selectedTab,
                        minutes: minutes,
                        onChange: onChangeMinutes
                    })
                ]
            }),
            isRecurring && !isVendor && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        children: contentTexts.cadenceConnectorUpTo()
                    }),
                    /*#__PURE__*/ _jsx(CadenceTimesDropdown, {
                        times: times,
                        onChange: onChangeTimes
                    })
                ]
            })
        ]
    });
};
